import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useAppInitialization = (setAppLoaded, checkAuth, fetchTasks) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const isAuthenticated = await checkAuth();
        if (isAuthenticated) {
          await fetchTasks();
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        navigate("/");
      } finally {
        setAppLoaded(true);
      }
    };
    checkAuthStatus();
  }, [navigate, checkAuth, setAppLoaded, fetchTasks]);
};
